<template>
    <div class="remote-consultation clearfix">
        <div class="remote-consultation-wrap marginP">
            <div class="search-content-bar" style="height:102px;overflow: auto;">
                <label class="searchTip">患者姓名</label>
                <el-input v-model="consulterName" placeholder="请填写患者姓名"size="small" style="width:120px;" />
                <label class="searchTip" style="margin-left:20px;" >申请机构</label>
                <!--v-show="mark=='init'"-->
                <el-select v-model="initHosId"
                           placeholder="请选择医院"
                           :clearable=true
                           @change="getHospId"
                           size="small">
                    <!--v-show="mark=='init'"-->
                    <el-option
                            v-for="item in hospList"
                            :label="item.hosName"
                            :value="item.id"
                            :key="item.id">
                    </el-option>
                </el-select>
                <!--<label class="searchTip" style="margin-left:20px;" v-show="mark=='accept'">会诊机构</label>-->
                <!--<el-select-->
                        <!--v-model="acceptHosId"-->
                        <!--placeholder="请选择医院"-->
                        <!--:clearable=true-->
                        <!--size="small"-->
                        <!--v-show="mark=='accept'"-->
                        <!--@change="getHospIds">-->
                    <!--<el-option v-for="item in hospLists" :label="item.hosName" :value="item.id" :key="item.id"/>-->
                <!--</el-select>-->
                <br>
                <label class="searchTip">安排会诊时间</label>
                <el-date-picker
                        v-model="startTime"
                        type="date"
                        placeholder="选择日期"
                        size="small"
                        >
                </el-date-picker>
                -
                <el-date-picker
                        v-model="endTime"
                        type="date"
                        placeholder="选择日期"
                        size="small"
                        >
                </el-date-picker>
                <!--<label class="searchTip" style="margin-left:20px;">快速搜索</label>-->
                <!--<input v-model="searchKey" type="search" class="search-content-input"/>-->
                <el-button size="small" type="primary" class="search-btn btn" @click="searchHandler">
                    查询
                </el-button>
                <el-button
                        size="small"
                        type="primary"
                        @click="linkDocToAss"
                        class="sponsored-btn btn">
                    发起会诊
                </el-button>
            </div>
            <div style="height: 10px; background-color: #F6F2EC"></div>
            <div class="tabLine" style="border: 1px solid #E5E5E5;">
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_dcl" v-if="identity=='ASS'" class="badge-9 tab-badge"/>
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_dhz" class="badge-8 tab-badge"/>
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_ywc" class="badge-6 tab-badge"/>
                <el-badge is-dot :hidden="!isGetNewMsg_ychz_yqx" class="badge-7 tab-badge"/>
                <el-tabs @tab-click="changeTab" v-model="activeName" class="tabRow">
                    <!--<el-tab-pane v-show="identity=='ASS'" label="待处理" name="toDeal" />-->
                    <el-tab-pane v-if="identity=='ASS'" label="待处理" name="toDeal" />
                    <el-tab-pane label="待会诊" name="toTreat"/>
                    <!--<el-tab-pane label="待会诊" name="toVideo"/>-->
                    <el-tab-pane label="已完成" name="finished"/>
                    <el-tab-pane label="已取消" name="cancelled"/>
                </el-tabs>
            </div>
            <!--各标签列表内容-->
            <div class="tabLine-content">
                <!--待处理标签内容-->
                <div v-show="activeName == 'toDeal' ">
                    <RemoteConsultationTableCmp5 :propsTableData="contentData1" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage1" :propsPageSize="7"/>
                </div>
                <!--处理中标签内容-->
                <div v-show="activeName == 'toTreat' ">
                    <RemoteConsultationTableCmp6 :propsTableData="contentData2" tableType="ychz_dhz" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage2" :propsPageSize="7"/>
                </div>
                <!--待会诊标签内容-->
                <!--<div v-show="activeName == 'toVideo' ">-->
                    <!--&lt;!&ndash;可用contentDataArr2代替3 两个内容一致&ndash;&gt;-->
                    <!--<RemoteConsultationTableCmp2 :propsTableData="contentData3" tableType="ychz_dhz" v-loading="!isSuccess"/>-->
                    <!--<FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage3" :propsPageSize="7"/>-->
                <!--</div>-->
                <!--已结束标签内容-->
                <div v-show="activeName == 'finished' ">
                    <RemoteConsultationTableCmp4 :propsTableData="contentData4" tableType="ychz_ywc" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage4" :propsPageSize="7"/>
                </div>
                <div v-show="activeName == 'cancelled' ">
                    <RemoteConsultationTableCmp7 :propsTableData="contentData4" tableType="ychz_yqx" v-loading="!isSuccess"/>
                    <FooterCmp :propsTotalCols="propsTotalCols"  @changePage="changePage4" :propsPageSize="7"/>
                </div>
            </div>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import { Badge, Button,Input,Tabs,TabPane, Loading, Message} from "element-ui";
    import axiosUtil from "../../utils/AxiosUtils.js";
    import { formatUnixTime } from "../../utils/DateFormat.js";
    import RemoteConsultationTableCmp1 from "./RemoteConsultationTableCmp1.vue";
    import RemoteConsultationTableCmp2 from "./RemoteConsultationTableCmp2.vue";
    import RemoteConsultationTableCmp4 from "./RemoteConsultationTableCmp4.vue";
    import RemoteConsultationTableCmp5 from "./RemoteConsultationTableCmp5.vue";
    import RemoteConsultationTableCmp6 from "./RemoteConsultationTableCmp6.vue";
    import RemoteConsultationTableCmp7 from "./RemoteConsultationTableCmp7.vue";
    import {upLoadBasicParam} from "../../data/basicParam.js";
    import FooterCmp from "../common/FooterCmp.vue";
    import Vue from "vue";
    Vue.use(Badge);
    Vue.use(Button);
    Vue.use(Input);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Loading);
    export default{
        data: function(){
            return {
                activeName: "",//切换标签的值
                searchKey: "",// 搜索内容
                propsTotalCols: 0,//列表总数量
                contentData1: [],
                initHosId:'',//发起医院
                acceptHosId:'',//接受医院
                startTime:'',//开始时间
                endTime:'',//结束时间
                consulterName:'',//患者姓名
                contentData2: [],
                time1:'',
                time2:'',
                hospList:[],
                hospLists:[],
                contentData3: [],
                contentData4: [],
                /*currentPage1: 1,//列表1当前页数
                 currentPage2: 1,//列表2当前页数
                 currentPage3: 1,//列表3当前页数
                 currentPage4: 1,//列表4当前页数*/
                isSuccess: false,//是否加载成功
                tab:this.$route.params.tab,
                mark:localStorage.getItem('hosMark'),
                identity:JSON.parse(localStorage.getItem('userInfo')).doc.docType
            }
        },
        created: function(){

            if(this.mark=='init'){
                if(this.tab!="finished"&&this.identity!="DOC"){//医助显示待处理
                    this.activeName="toDeal";
                    this.getData( "smarthos.consult.group.waithandle.list","init", "contentData1", "","","","","","", 1);
                }else if(this.tab!="finished"&&this.identity=="DOC"){//医生显示待会诊
                    this.activeName="toTreat";
                    this.getData("smarthos.consult.group.waitvideo.list","init", "contentData2", "","","","","","", 1);
                }else{//已完成路由跳转显示已完成
                    this.activeName="finished";
                    this.getData("smarthos.consult.group.comment.list","init", "contentData4", "","","","","","", 1);
                }
                this.aspectUser="init";
            }else{
                if(this.tab!="finished"&&this.identity!="DOC"){//医助显示待处理
                    this.activeName="toDeal";
                    this.getData( "smarthos.consult.group.waithandle.list","accept", "contentData1", "","","","","","", 1);
                }else if(this.tab!="finished"&&this.identity=="DOC"){//医生显示待会诊
                    this.activeName="toTreat";
                    this.getData("smarthos.consult.group.waitvideo.list","accept", "contentData2", "","","","","","", 1);
                }else{//已完成路由跳转显示已完成
                    this.activeName="finished";
                    this.getData("smarthos.consult.group.comment.list","accept", "contentData4", "","","","","","", 1);

                }
                this.aspectUser="accept";
            }
            this.$store.dispatch("changeSideItem", "ychz");//侧边栏高亮 消除侧边栏
        },
        components:{
            RemoteConsultationTableCmp1,
            RemoteConsultationTableCmp4,
            RemoteConsultationTableCmp5,
            RemoteConsultationTableCmp6,
            RemoteConsultationTableCmp7,
            FooterCmp
        },
        computed: {
            isGetNewMsg_ychz_dcl: function() {// 待处理
                return this.$store.state.isGetNewMsg_ychz_dcl;
            },
            isGetNewMsg_ychz_dhz: function() {// 待会诊
                return this.$store.state.isGetNewMsg_ychz_dhz;
            },
            // isGetNewMsg_ychz_wsd: function() {// 我收到
            //     return this.$store.state.isGetNewMsg_ychz_wsd;
            // },
            isGetNewMsg_ychz_ywc: function() {// 已完成
                return this.$store.state.isGetNewMsg_ychz_ywc;
            },
            isGetNewMsg_ychz_yqx: function() {// 已取消
                return this.$store.state.isGetNewMsg_ychz_yqx;
            },
        },
        mounted:function(){
            this.getHospList();
            this.getHospLists();
        },
        methods: {
            getData: function( service,aspectUser, contentDataType=[], searchKey="",endTime="",startTime="",acceptHosId="",consulterName="",initHosId="", pageNo=1, sort="modify_time.desc"){//使用axios获取数据 函数封装避免重复代码
                let _this=this;
                startTime=formatUnixTime(startTime)?formatUnixTime(startTime):'';
                endTime=formatUnixTime(endTime)?formatUnixTime(endTime):'';
                if(_this.activeName=="toDeal"){
                    let options = {
                        aspectUser: aspectUser,
                        searchKey: searchKey,
                        startTime:startTime,
                        endTime:endTime,
                        hopeHosId:acceptHosId,
                        consulterName:consulterName,
                        initHosId:initHosId,
                        pageNo: pageNo,
                        pageSize: 7,
                        sort: sort,
                        searchRange:JSON.parse(sessionStorage.getItem("loginInfo")).doc.docType=="ASS"?"HOS":"PERSON",
                        token: localStorage.getItem("token"),
                        Service: service
                    };
                    axiosUtil(options, function(data){
                        _this.isSuccess = true;
                        _this.propsTotalCols = data.page.total;
                        switch (contentDataType){//根据切换的标签获取不同数据
                            case "contentData1":
                                _this.contentData1=[];
                                for(var i=0;i<data.list.length;i++){
                                    _this.contentData1.push(data.list[i].consultGroup);
                                }

                                break;
                            case "contentData2":
                                _this.contentData2=[];
                                for(var i=0;i<data.list.length;i++){
                                    _this.contentData2.push(data.list[i].consultGroup);
                                }

                                break;
                            case "contentData3":
                                _this.contentData4=[];
                                for(var i=0;i<data.list.length;i++){
                                    _this.contentData4.push(data.list[i].consultGroup);
                                }
                                break;
                            case "contentData4":
                                _this.contentData4=[];
                                for(var i=0;i<data.list.length;i++){
                                    _this.contentData4.push(data.list[i].consultGroup);
                                }
                                break;
                            default:
                                _this.contentData1 = data.list;
                                break;
                        }
                    }, function () {
                        _this.isSuccess = true;
                    });
                }else{
                    let options = {
                        aspectUser: aspectUser,
                        searchKey: searchKey,
                        startTime:startTime,
                        endTime:endTime,
                        acceptHosId:acceptHosId,
                        consulterName:consulterName,
                        initHosId:initHosId,
                        pageNo: pageNo,
                        pageSize: 7,
                        sort: sort,
                        searchRange:JSON.parse(sessionStorage.getItem("loginInfo")).doc.docType=="ASS"?"HOS":"PERSON",
                        token: localStorage.getItem("token"),
                        Service: service
                    };
                    axiosUtil(options, function(data){
                        _this.isSuccess = true;
                        _this.propsTotalCols = data.page.total;
                        switch (contentDataType){//根据切换的标签获取不同数据
                            case "contentData1":
                                _this.contentData1=[];
                                for(var i=0;i<data.list.length;i++){
                                    _this.contentData1.push(data.list[i].consultGroup);
                                }

                                break;
                            case "contentData2":
                                _this.contentData2=[];
                                for(var i=0;i<data.list.length;i++){
                                    _this.contentData2.push(data.list[i].consultGroup);
                                }

                                break;
                            case "contentData3":
                                _this.contentData4=[];
                                for(var i=0;i<data.list.length;i++){
                                    _this.contentData4.push(data.list[i].consultGroup);
                                }
                                break;
                            case "contentData4":
                                _this.contentData4=[];
                                for(var i=0;i<data.list.length;i++){
                                    _this.contentData4.push(data.list[i].consultGroup);
                                }
                                break;
                            default:
                                _this.contentData1 = data.list;
                                break;
                        }
                    }, function () {
                        _this.isSuccess = true;
                    });
                }
            },
            getTabList: function(service,aspectUser,tabName, searchKey="",pageNo=1 ,endTime="",startTime="",acceptHosId="",consulterName="",initHosId="",) {// 获取列表
                this.isSuccess = false;
                switch(tabName){
                    case "toDeal"://待处理
                        this.$store.dispatch("isGetNewMsg_ychz_dcl", false);// 清除小红点
                        this.getData("smarthos.consult.group.waithandle.list",aspectUser, "contentData1", searchKey,endTime,startTime,acceptHosId,consulterName,initHosId, pageNo);
                        break;
                    case "toTreat"://待会诊
                        this.$store.dispatch("isGetNewMsg_ychz_dhz", false);// 清除小红点
                        // this.$store.dispatch("isGetNewMsg_ychz_wsd", false);// 清除小红点
                        this.getData("smarthos.consult.group.waitvideo.list",aspectUser, "contentData2", searchKey,endTime,startTime,acceptHosId,consulterName,initHosId, pageNo);
                        break;
//                    case "toVideo"://待会诊
//                        this.$store.dispatch("isGetNewMsg_ychz_dhz", false);// 清除小红点
//                        this.getData("accept",["2"], "waitVideo", "contentData3", searchKey,endTime,startTime,acceptHosId,consulterName,initHosId, pageNo);
//                        break;
                    case "finished"://已结束/已取消
                        this.$store.dispatch("isGetNewMsg_ychz_ywc", false);// 清除小红点
                        this.getData("smarthos.consult.group.comment.list",aspectUser, "contentData4", searchKey,endTime,startTime,acceptHosId,consulterName,initHosId, pageNo);
                        break;
                    case "cancelled"://已结束/已取消
                        this.$store.dispatch("isGetNewMsg_ychz_yqx", false);// 清除小红点
                        this.getData("smarthos.consult.group.cancel.list",aspectUser, "contentData4", searchKey,endTime,startTime,acceptHosId,consulterName,initHosId, pageNo);
                        break;
                    default:
                        this.$store.dispatch("isGetNewMsg_ychz_dcl", false);// 清除小红点
                        this.getData("smarthos.consult.group.waithandle.list",aspectUser, "contentData1", searchKey, pageNo);
                        break;
                }
            },
            changeTab: function(tab){//标签切换
                this.searchKey = "";
                this.getTabList(this.service,this.aspectUser,tab.name, this.searchKey, 1,this.endTime,this.startTime,this.acceptHosId,this.consulterName,this.initHosId);
                this.activeName = tab.name;
            },
            changePage1: function(pageNo){//各个标签改变页数
                this.getTabList(this.service,this.aspectUser,this.activeName, this.searchKey, pageNo,this.endTime,this.startTime,this.acceptHosId,this.consulterName,this.initHosId);
            },
            changePage2: function(pageNo){
                this.getTabList(this.service,this.aspectUser,this.activeName, this.searchKey, pageNo,this.endTime,this.startTime,this.acceptHosId,this.consulterName,this.initHosId);
            },
            changePage3: function(pageNo){
                this.getTabList(this.service,this.aspectUser,this.activeName, this.searchKey, pageNo,this.endTime,this.startTime,this.acceptHosId,this.consulterName,this.initHosId);
            },
            changePage4: function(pageNo){
                this.getTabList(this.service,this.aspectUser,this.activeName, this.searchKey, pageNo,this.endTime,this.startTime,this.acceptHosId,this.consulterName,this.initHosId);
            },
            linkDocToAss: function () {//发起医助医会诊
                this.$store.dispatch("getConsultType", "ASS");
                this.$router.push("remoteConsultation/launch");
            },
            linkDoc: function () {//发起医医会诊
                this.$store.dispatch("getConsultType", "DOC");
                this.$router.push("remoteConsultation/launch");
            },
            launchConsul: function(){//跳转到发起会诊页面
                this.$router.push("remoteConsultation/launch");
            },
            searchHandler: function(){// 搜索内容
                this.startTime=formatUnixTime(this.startTime)?formatUnixTime(this.startTime):'';
                this.endTime=formatUnixTime(this.endTime)?formatUnixTime(this.endTime):'';
                let st = parseInt(this.startTime.substring(0,4)+this.startTime.substring(5,7)+this.startTime.substring(8,10));
                let et = parseInt(this.endTime.substring(0,4)+this.endTime.substring(5,7)+this.endTime.substring(8,10));
                if(st>et){
                    Message({
                        message: '结束时间不能小于开始时间',
                        type: 'warning'
                    });
                    return
                }

                this.getTabList(this.service,this.aspectUser,this.activeName, this.searchKey,1 ,this.endTime,this.startTime,this.acceptHosId,this.consulterName,this.initHosId);
            },
            getHospList: function(){//获取医院列表,参数未显示下拉菜单和隐藏下拉菜单的boolean，下来为true
                    this.loading = true;
                    let _this = this;
                    let options = {
                        Service: "smarthos.system.hos.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.hospList = data.list;
                    });
            },
            getHospId: function(id){//获取选择的医院id
                let _this=this;
                _this.initHosId=id;
            },
            getHospLists: function(showList){//获取医院列表,参数未显示下拉菜单和隐藏下拉菜单的boolean，下来为true
                    this.loading = true;
                    let _this = this;
                    let options = {
                        Service: "smarthos.system.hos.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.hospLists = data.list;
                    });
            },
            getHospIds: function(id){//获取选择的医院id
                let _this=this;
                _this.acceptHosId = id;
            },
        }
    }
</script>
